import { Model } from '../parents/model';

export class EcoChallengeFileOrdersModel extends Model {
  static ATTR_ID = 'id';

  static ATTR_PARSED_CODE = 'parsed_code';

  static ATTR_LOADED_CODE = 'loaded_code';

  static ATTR_NOTE = 'note';

  static ATTR_IS_PAIRED = 'is_paired';

  static ATTR_ECO_CHALLENGE_FILE_ID = 'eco_challenge_file_id';

  get parsedCode() {
    return this.attributes[EcoChallengeFileOrdersModel.ATTR_PARSED_CODE];
  }

  get loadedCode() {
    return this.attributes[EcoChallengeFileOrdersModel.ATTR_LOADED_CODE];
  }

  get note() {
    return this.attributes[EcoChallengeFileOrdersModel.ATTR_NOTE];
  }

  get isPaired() {
    return this.attributes[EcoChallengeFileOrdersModel.ATTR_IS_PAIRED];
  }

  get ecoChallengeFileId() {
    return this.attributes[EcoChallengeFileOrdersModel.ATTR_ECO_CHALLENGE_FILE_ID];
  }
}
